export const getInitials = (firstName = '', lastName = ''): string =>
  `${firstName.slice(0, 1)}${lastName.slice(0, 1)}`.toUpperCase();
